/**
 * Hike Society Event – product carousel (desktop + mobile).
 */
(function () {
  'use strict';

  function initSection(root) {
    if (!root || root.dataset.hseInitialized === 'true') return;
    root.dataset.hseInitialized = 'true';

    var track = root.querySelector('[data-hse-products-track]');
    var prevBtn = root.querySelector('[data-hse-products-prev]');
    var nextBtn = root.querySelector('[data-hse-products-next]');
    var dotsContainer = root.querySelector('[data-hse-products-dots]');
    if (!track) return;

    var index = 0;

    function getSlidesPerView() {
      if (window.innerWidth <= 720) return 2;
      if (window.innerWidth <= 1024) return 2;
      return 4;
    }

    function getSlides() {
      return Array.prototype.slice.call(
        track.querySelectorAll('.vtex-slider-layout-0-x-slide--Productos-hires')
      );
    }

    function getStepPx() {
      var container = track.parentElement;
      if (!container) return 0;
      return container.getBoundingClientRect().width / getSlidesPerView();
    }

    function getMaxIndex() {
      var slides = getSlides();
      var perView = getSlidesPerView();
      return Math.max(0, slides.length - perView);
    }

    function getDotCount() {
      return getMaxIndex() + 1;
    }

    function buildDots() {
      if (!dotsContainer) return;

      dotsContainer.innerHTML = '';
      var dotCount = getDotCount();

      for (var i = 0; i < dotCount; i += 1) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'hse-slider-dot' + (i === index ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Ir al slide ' + (i + 1));
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
        dot.dataset.dotIndex = String(i);
        dot.addEventListener('click', function () {
          index = Number(this.dataset.dotIndex);
          updateSlider();
        });
        dotsContainer.appendChild(dot);
      }
    }

    function updateDots() {
      if (!dotsContainer) return;

      var dots = dotsContainer.querySelectorAll('.hse-slider-dot');
      Array.prototype.forEach.call(dots, function (dot, dotIndex) {
        var isActive = dotIndex === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    function updateSlider() {
      var maxIndex = getMaxIndex();

      if (index > maxIndex) index = maxIndex;
      if (index < 0) index = 0;

      track.style.transform = 'translate3d(-' + index * getStepPx() + 'px, 0, 0)';

      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= maxIndex;

      if (dotsContainer && dotsContainer.children.length !== getDotCount()) {
        buildDots();
      } else {
        updateDots();
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        index -= 1;
        updateSlider();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        index += 1;
        updateSlider();
      });
    }

    window.addEventListener('resize', function () {
      buildDots();
      updateSlider();
    });

    buildDots();
    updateSlider();
  }

  function boot() {
    document.querySelectorAll('[data-hike-society-event]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-hike-society-event]');
    if (root) initSection(root);
  });
})();
